import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "card-item-proxy__empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardItemTile = _resolveComponent("CardItemTile")!
  const _component_CardItemRow = _resolveComponent("CardItemRow")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card-item-proxy", _ctx.classes])
  }, [
    (_ctx.display)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.isShort)
            ? (_openBlock(), _createBlock(_component_CardItemTile, _mergeProps({ key: 0 }, _ctx.$props, {
                onAction: _ctx.actionHandler,
                onSelect: _ctx.selectHandler
              }), null, 16, ["onAction", "onSelect"]))
            : (_openBlock(), _createBlock(_component_CardItemRow, _mergeProps({ key: 1 }, _ctx.$props, {
                onAction: _ctx.actionHandler,
                onSelect: _ctx.selectHandler
              }), null, 16, ["onAction", "onSelect"]))
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_1))
  ], 2))
}